import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType"
import "./ReceiveReturnAcquisitions.scss"


const initState = {
  lSupplierKey: 0,
  Inactive: false,
  lSupplierPOKey: 0,
  isPOshow: false,
  iscomplete: false,
  ismonthly: 6,
}

export const ReceiveReturnAcqisitionfilterFormData = {
  name: "Receive/Return Acqisition filter",
  initialState: initState,
  section: [
    {
      sectionId: "basicDetailSection",
      title: "Profile Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12",
      },
      wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "lSupplierKey",
          label: "Supplier :",
          Field_Name: "Supplier :",
          fieldType: FormFieldTypes.SELECT,
          dataField: "lSupplierKey",
          fieldSetting: {
            placeholder: "Select Supplier",
            allowSpace: true,
            options: [],
          },
          // validation: [{ type: "require" }],
          style: {
            containerCss: "col-lg-6 col-md-4 col-4 mb-2 po-input",
          },
        },
        {
          id: "Inactive",
          label: "Include Inactive",
          Field_Name: "Include Inactive",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "Inactive",
          fieldSetting: {
            placeholder: "  ",
            subTitle: " ",
          },
          style: {
            containerCss: "col-lg-6 col-md-3 po-input",
          },
        },
        {
          id: "isPOshow",
          label: "PO :",
          Field_Name: "PO :",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isPOshow",
          fieldSetting: {
            placeholder: "  ",
            subTitle: " ",
          },
          style: {
            containerCss: "recevi-return-checkbox po-input",
          },
        },
        {
          id: "lSupplierPOKey",
          label: "",
          Field_Name: "",
          fieldType: FormFieldTypes.SELECT,
          dataField: "lSupplierPOKey",
          fieldSetting: {
            placeholder: "Select Purchase Order",
            subTitle: " ",
            isDisable: true,
            options: [],
          },
          style: {
            containerCss: "col-lg-5 col-md-2 align-item-center po-input purchase-order-dropdown",
          },
        },
        {
          id: "iscomplete",
          label: "Show Completed POs",
          Field_Name: "iScomplete",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "iscomplete",
          fieldSetting: {
            placeholder: "  ",
            subTitle: " ",
          },
          style: {
            containerCss: "col-lg-2 col-md-4 col-4 po-input",
          },
        },
        {
          id: "ismonthly",
          label: "POs From The Past",
          Field_Name: "iScomplete",
          fieldType: FormFieldTypes.INPUT,
          dataField: "ismonthly",
          fieldSetting: {
            placeholder: "  ",
            subTitle: " ",
          },
          style: {
            containerCss: "col-lg-2 col-md-4 col-4  po-input po-input-box",
          },
        },
        {
          id: "ismonthly",
          label: "Months.",
          Field_Name: "iScomplete",
          fieldType: FormFieldTypes.INPUT,
          dataField: "ismonthly",
          fieldSetting: {
            placeholder: "  ",
            subTitle: " ",
          },
          style: {
            containerCss: "col-lg-1 col-md-4 col-4  po-input-none",
          },
        },
      ],
    }
  ]
}